export const SOLICITA_COBRO_INICIAL_REQUEST = 'SOLICITA_COBRO_INICIAL_REQUEST';
export const SOLICITA_COBRO_INICIAL_SUCCESS = 'SOLICITA_COBRO_INICIAL_SUCCESS';
export const SOLICITA_COBRO_INICIAL_FAILURE = 'SOLICITA_COBRO_INICIAL_FAILURE';
